export const SET_IS_SHOW_EDIT_ASSET_FORM = 'layout/IS_SHOW_EDIT_ASSET_FORM';
export const SET_ASSET_TO_EDIT = 'layout/SET_ASSET_TO_EDIT';
export const SET_IS_SHOW_SUBSCRIPTION_WIDGET =
  'layout/IS_SHOW_SUBSCRIPTION_WIDGET';
